/* eslint-disable @typescript-eslint/no-explicit-any */
import { useQuery } from 'react-query';
import { API } from 'api';

export interface ILapseRepaymentListData {
  payload: {
    page?: number;
    from?: number;
    to?: number;
    eid?: string;
    status?: string;
  };
  data: {
    data: any;
    count: number;
  };
}

export const initLapseRepaymentListPayload: ILapseRepaymentListData['payload'] = {
  page: 1,
};

const getLapseRepaymentListData = (data: ILapseRepaymentListData['payload']) => {
  return API.get()('/api/admin/lapsepayment', data);
};

export const useLapseRepaymentListData = (data: ILapseRepaymentListData['payload']) => {
  return useQuery(['lapseRepayments', data], (): any => getLapseRepaymentListData(data), {
    select: (response: ILapseRepaymentListData['data']) => {
      return response.data;
    },
  });
};
